import React, { useState } from 'react';
import './ForgotPasswordPage.css';

const API = `${process.env.REACT_APP_API_URL || 'https://api.guardianbazaar.com'}/api`;

export default function ForgotPasswordPage() {
  const [email,   setEmail]   = useState('');
  const [message, setMessage] = useState('');
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); setMessage('');
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setMessage(data.message);
      setSent(true);
    } catch {
      setError('Could not connect to the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-card">
        <a href="/login">
          <img src="/guardian-bazaar-logo-dark.png" alt="Guardian Bazaar" className="forgot-logo" />
        </a>
        <h1 className="forgot-title">Forgot your password?</h1>
        <p className="forgot-subtitle">
          Enter your email address and we'll send you a 6-digit reset code.
        </p>

        {!sent ? (
          <form className="forgot-form" onSubmit={handleSubmit}>
            <div className="forgot-field">
              <label>Email Address</label>
              <input type="email" value={email}
                     onChange={e => setEmail(e.target.value)}
                     placeholder="your@email.com"
                     autoFocus required />
            </div>
            {error && <div className="forgot-error">{error}</div>}
            <button type="submit" className="forgot-btn" disabled={loading}>
              {loading ? 'Sending…' : 'Send Reset Code'}
            </button>
          </form>
        ) : (
          <div className="forgot-sent">
            <div className="forgot-sent-icon">✉</div>
            <p>{message}</p>
            <p className="forgot-sent-note">
              Check your spam folder if you don't see it within a few minutes.
            </p>
            <a href="/reset-password" className="forgot-btn" style={{ marginTop: 16, display: 'inline-block', textDecoration: 'none' }}>
              Enter Reset Code
            </a>
          </div>
        )}

        <a href="/login" className="forgot-back">← Back to sign in</a>
      </div>
    </div>
  );
}
